import datSidebar from 'data/devapp_sidebar.json';
import DevTorontoLegend from 'data/dev-app-toronto-legend.json';
import blankLegend from 'data/blank-legend.json';
import addressWindowDev from 'client/templates/addressWindowDev.html';
import devAppFilterInfo from 'data/filter-layers-wms.json';
import { getHandlerFor } from 'client/utils/angular';
import { template } from 'underscore';

const CURRENT_YEAR = new Date().getUTCFullYear();
const DEFAULT_DEVCOORDS = {lng: 0, lat: 0, radius: 0, status: 'Null', type_selected: 'Null', year_min: 0, year_max: 0, plu: -1, myp_municipality: 'Null'};
const DEFAULT_DEVAPPFILTER = {radius: 0, type_selected: 'Null', status: 'Null', year_min: 0, year_max: 0, plu: -1, myp_municipality: 'Null'};
const DEFAULT_DEVAPPENABLED = {type: true, status: true, year_min: true, year_min: true, plu: false};
const DEFAULT_YEARRANGE_INFO = {
  minValue: 1994,
  maxValue: CURRENT_YEAR,
  options: {
    ceil: CURRENT_YEAR,
    floor: 1994,
    showTicks: false,
    showTicksValues: false,
    step: 1,
    draggableRange: false
  }
};

export default function($scope,Maps,$window,$rootScope,datorontoService,$compile,$timeout,ngDialog, historyService, sidebarService){

  $scope.devAccept = false;
  $scope.datSidebar = datSidebar;
  $scope.devAddress = '';
  $scope.devAppFilter = DEFAULT_DEVAPPFILTER;
  $scope.devCoords = DEFAULT_DEVCOORDS;
  $scope.devAppEnabled = DEFAULT_DEVAPPENABLED;

  $scope.DevTorontoLegend = DevTorontoLegend;
  $scope.switchStatus = true;
  $scope.filterLayer = "";

  //Tooltip for property lock/unlock
  $scope.tooltip_devapp_lock = {title:'Slide to unlock and select another property',checked: true};
  $scope.tooltip_devapp_unlock = {title:'Now select a property',checked: true};
  $scope.tooltip_devapp_radiusFilter = {title:'Filter by Radius (max 1500m)',checked: true};
  $scope.tooltip_devapp_yearFilter = {title:'Filter by Submission Year',checked: true};
  $scope.tooltip_devapp_statusFilter = {title:'Filter by Application Status',checked: true};
  $scope.tooltip_devapp_typeFilter = {title:'Filter by Development Type',checked: true};

  // pull values from sql queries for devapp sidebar dropdowns/options
  $scope.devappSidebar = Object.assign({}, datSidebar);
  const update = ({ devappstatus, devapptype, devappsubyear }) => {
    $scope.devappSidebar.devappstatus = {}; //Clear devapp Layer Information
    $scope.devappSidebar.devapptype = {}; //Clear devapp layer information
    $scope.devappSidebar.devappsubyear = {}; //Clear devapp layer information

    //Check for devapp status info
    if ('no_result' in devappstatus) {
      $scope.devappSidebar.devappstatus.error = devappstatus.no_result;
    } else if ('error' in devappstatus) {
      $scope.devappSidebar.devappstatus.error = devappstatus.error;
    } else {
      // set devapp info
      $scope.devappSidebar.devappstatus = devappstatus;
    }

    //Check for devapp type info
    if ('no_result' in devapptype) {
      $scope.devappSidebar.devapptype.error = devapptype.no_result;
    } else if ('error' in devapptype) {
      $scope.devappSidebar.devapptype.error = devapptype.error;
    } else {
      // set devapp info
      $scope.devappSidebar.devapptype = devapptype;
    }

    //Check for devapp year info
    if ('no_result' in devappsubyear) {
      $scope.devappSidebar.devappsubyear.error = devappsubyear.no_result;
    } else if ('error' in devappsubyear) {
      $scope.devappSidebar.devappsubyear.error = devappsubyear.error;
    } else {
      // set devapp info
      $scope.devappSidebar.devappsubyear = devappsubyear;

      DEFAULT_YEARRANGE_INFO.minValue = Number(devappsubyear[0].myp_submission_year_min);
      DEFAULT_YEARRANGE_INFO.maxValue = Number(devappsubyear[0].myp_submission_year_max);
      DEFAULT_YEARRANGE_INFO.options.floor = Number(devappsubyear[0].myp_submission_year_min);
      DEFAULT_YEARRANGE_INFO.options.ceil = Number(devappsubyear[0].myp_submission_year_max);
    }
  };

  if(!$scope.onSidebar) {
    sidebarService.sidebarInfo({
      type: "devapp_sidebar",
      gid: $scope.sidebar.gid,
      myp_municipality: $scope.sidebar.myp_municipality
    }).success(update);
  }

  //Check munic and load the correct legend into the sidebar
  $scope.devAppFilter.myp_municipality = $scope.myp_municipality;
  if($scope.myp_municipality == 'Toronto') {
    if($scope.legendTitle != "dat")
      $rootScope.$broadcast('map/setlegend', [DevTorontoLegend, "dat"]);
  } else {
    if($scope.legendTitle != "blank") {
      $rootScope.$broadcast('map/setlegend', [blankLegend, "blank"]);
    }
  }

  // Function for radius call.
  // The first load is always set to 0m; when radius is 0m, system loads the regular (non-filter, not function myp_devapp_filter_gs) devapp layer that displays the enter data (as per Devin).
  // Also if user manually inputs 0m radius without filters in devapp sidebar, loads entire layer
  function checkNoFilterCondition(devAppFilter, yearRange) {
    return (
      devAppFilter.radius === 0 &&
      devAppFilter.type_selected === 'Null' &&
      devAppFilter.status === 'Null' &&
      devAppFilter.year_min === yearRange.options.floor &&
      devAppFilter.year_max === yearRange.options.ceil
    );
  };

  $scope.sendRadius = function(radius){
    if (typeof radius === 'string') {
      radius = radius.replace(/\D+/g, '').replace(/^0+/g, 0);
    }
    $scope.devAppFilter.radius = radius;
    $scope.sendFilter();
  };

  // Function used to call filter layer based on user input
  if ($scope.myp_municipality == 'Toronto') {
    devAppFilterInfo[0]['link'] = "myp3:ca_on_toronto_cty_toronto_devappaic"
  } else {
    devAppFilterInfo[0]['link'] = "myp3:ca_on_toronto_reg_york_devapp"
  };

  $scope.sendFilter = function(){
    if (checkNoFilterCondition($scope.devAppFilter, $scope.yearRange)) {
      $scope.setFilterLayer(devAppFilterInfo[0],'default');
    } else {
      $scope.setFilterLayer(devAppFilterInfo[1],'default');
    };
    $rootScope.$broadcast('sidebar/report/updatereportfilter', $scope.devAppFilter);
    $rootScope.$broadcast('sidebar/report/checkcount');
  };

  // Function used to reset the filter layer
  $scope.resetFilter = function(){
    // Reset Layer
    if (checkNoFilterCondition($scope.devAppFilter, $scope.yearRange)) {
      $scope.setFilterLayer(devAppFilterInfo[0],'default');
    } else {
      $scope.setFilterLayer(devAppFilterInfo[1],'default');
    };

    //  Reset Filters
    $scope.devAppFilter = Object.assign({}, DEFAULT_DEVAPPFILTER);
  };

  $scope.$watch('radius', function(){
    $scope.sendFilter();
  });
  $scope.$watch('devAppFilter.type_selected', function(){
    $scope.sendFilter();
  });
  $scope.$watch('devAppFilter.status', function(){
    $scope.sendFilter();
  });
  // $scope.$watch('devAppFilter.plu', function(){
  //   $scope.sendFilter();
  // });

  // set year filter
  $scope.yearRange = DEFAULT_YEARRANGE_INFO;

  $scope.minYearRangeCount = 0;
  $scope.maxYearRangeCount = 0;

  $scope.$watch('yearRange.minValue', function(){
    if($scope.minYearRangeCount > 0){
      $scope.devAppFilter.year_min = $scope.yearRange.minValue;
      $scope.devAppFilter.year_max = $scope.yearRange.maxValue;
      $scope.sendFilter();
    }else{
      $scope.minYearRangeCount++;
    }
  });

  $scope.$watch('yearRange.maxValue', function(){
    if($scope.maxYearRangeCount > 0){
      $scope.devAppFilter.year_max = $scope.yearRange.maxValue;
      $scope.devAppFilter.year_min = $scope.yearRange.minValue;
      $scope.sendFilter();
    }else{
      $scope.maxYearRangeCount++;
    }
  });

  //Functioin used to unlock the parcel click
  $scope.unlockParcel = function(iLock){
    if(iLock == false) {
      $rootScope.$broadcast('unlock');
      $rootScope.parcelLock = iLock;
    }else{
      $rootScope.parcelLock = iLock;
    }
  };

  //Turn on & off WMS filter layers
  $scope.setFilterLayer = function(layer,type){

    // reset tilesLoaded
    $rootScope.tilesLoaded = false;

    var count = 0;
    //Turn off all Dev App Filter layers
    for(var index in $rootScope.mapLayers){
      if($rootScope.mapLayers[index].alt == 'dev-app-toronto'){
        if ($scope.map.overlayMapTypes.getAt(index) != null && $scope.map.overlayMapTypes.getAt(index) != undefined)
          $scope.map.overlayMapTypes.setAt(index, null);
      }
      count++;
    };
    // console.log($rootScope.mapLayers);
    $scope.layerIndex = count + 1;
    $scope.filterLayer = new google.maps.ImageMapType({

      getTileUrl: function(coord, zoom){
        var proj = $scope.map.getProjection();
        var zfactor = Math.pow(2, zoom);
        // get Long Lat coordinates
        var top = proj.fromPointToLatLng(new google.maps.Point(coord.x * 256 / zfactor, coord.y * 256 / zfactor));
        var bot = proj.fromPointToLatLng(new google.maps.Point((coord.x + 1) * 256 / zfactor, (coord.y + 1) * 256 / zfactor));

        var deltaX = 0; // Any corrections in X,Y needed (none at this point)
        var deltaY = 0;

        //create the Bounding box string
        var bbox = (top.lng() + deltaX) + "," +
          (bot.lat() + deltaY) + "," +
          (bot.lng() + deltaX) + "," +
          (top.lat() + deltaY);
        //Determine which type of filter needs to be returned

        var schema = 'on';
        var parcel_table = 'myp_cityplanner_parcel';
        var devapp_table = 'ca_on_toronto_cty_toronto_devappaic';
        var styles = 'ca_on_toronto_cty_toronto_devapp';

        if ($scope.myp_municipality != 'Toronto') {
          var devapp_table = 'ca_on_toronto_reg_york_devapp';
          var styles = 'ca_on_toronto_reg_york_devapp';
        };

        var epsg = 4326;

        var myp_status_value = encodeURIComponent($scope.devAppFilter.status);
        var myp_type_description_value = encodeURIComponent($scope.devAppFilter.type_selected);
        var myp_submission_year_start_value = $scope.yearRange.minValue;
        var myp_submission_year_end_value = $scope.yearRange.maxValue;

        switch(type){
          default:
            var viewparams = "";
            if (!checkNoFilterCondition($scope.devAppFilter, $scope.yearRange)) {
              viewparams = "&viewparams=radius:" + $scope.devAppFilter.radius + ";gid:" + $rootScope.propNumber + ";epsg:" + epsg + ";schema:" + schema + ";devapp_table:" + devapp_table + ";parcel_table:" + parcel_table + ";myp_status_value:" + myp_status_value + ";myp_type_description_value:" + myp_type_description_value + ";myp_submission_year_start_value:" + myp_submission_year_start_value + ";myp_submission_year_end_value:" + myp_submission_year_end_value;
            };

            var devapp_gs_url = $window.url_gs_dev_app + "service=WMS" + "&version=1.1.0" + "&request=GetMap" + "&layers=" + layer.link + "&zoom=" + zoom + "&styles=" + styles + "&BBOX=" + bbox + "&WIDTH=256" + "&HEIGHT=256" + "&srs=EPSG:" + epsg + "&format=" + layer.format + "&bgcolor=0xFFFFFF" + "&transparent=TRUE" + "&tiled=true" + viewparams;
            return devapp_gs_url;
        }
      },
      tileSize: new google.maps.Size(layer.size,layer.size),
      isPng: layer.isPng,
      opacity: layer.opacity,
      name: layer.name,
      alt: layer.type

    });

    $scope.map.overlayMapTypes.setAt($scope.layerIndex,$scope.filterLayer);

    // Check if layer tiles finished loading https://stackoverflow.com/questions/72225987/is-there-any-event-listener-to-check-if-the-wms-layer-has-loaded-or-not-in-googl
    $scope.filterLayer.addListener("tilesloaded", () => {
      $rootScope.tilesLoaded = true;
      $rootScope.$apply();
      // console.log("...tiles loaded");
    });

    // reset tilesLoaded to false...somehow this fixes the issue when there is only a small 'addListener...bounds_change), tilesloaded code above doesn't get triggered
    // likely due no change in tiles or new tiles in the visible extent
    // https://stackoverflow.com/questions/832692/how-can-i-check-whether-google-maps-is-fully-loaded
    google.maps.event.addListener($scope.map, 'tilesloaded', function(){
      $rootScope.tilesLoaded = false;
      $rootScope.$apply();
    });

    // This code will execute after 30 seconds and set $rootScope.tilesLoaded to false.
    setTimeout(() => {
      $rootScope.tilesLoaded = true;
      $rootScope.$apply();
    }, 60000); // 30 seconds in milliseconds

  };

  if($rootScope.isDev == false) {
    //Closer current info window
    $scope.setInfoContent($rootScope.address,'dev-address');

    //Turn on filter layer
    $scope.setFilterLayer(devAppFilterInfo[0],'default');

    $rootScope.isDev = true;
    $rootScope.$broadcast('locationToggle');

    if(!checkNoFilterCondition($scope.devAppFilter, $scope.yearRange)) {
      $scope.sendFilter();
    }
  };


  datorontoService.disclaimerCheck().success(function (data) {
    ngDialog.closeAll();
    ngDialog.open({
      templateUrl: '/templates/dat-disclaimer.html',
      className: 'ngdialog-theme-default',
      controller: ['$scope', 'datorontoService', function ($scope, datorontoService) {
        //Function for disclaimer
        $scope.acceptDisclaimer = function () {
          ngDialog.closeAll();
          datorontoService.disclaimerAccept().success(function (data) {

          });
        };
      }]
    });
  });

  const updateDevCoords = (lat, lng) => {
    const {radius, status, type_selected, year_min, year_max, plu, myp_municipality} = $scope.devAppFilter;

    $scope.devCoords = Object.assign($scope.devCoords, {
      lat,
      lng,
      radius,
      status,
      type_selected,
      year_min,
      year_max,
      plu,
      myp_municipality
    });
  };

  const updateDevAppInfo = () => {
    datorontoService.devappInfo($scope.devCoords).success(function (response){
      if (response) {
        const devAppInfo = [].concat(response);

        devAppInfo.forEach((info) => {
          const {
            address, devapp_application_no, myp_label_custom, myp_id, myp_permitapp_id, myp_development_name, myp_address, myp_status, myp_label, myp_type_description, myp_submission_date,
            myp_decision_date, myp_municipality, myp_neighbourward, myp_policy_url, myp_map_url, myp_description, myp_landuse, myp_zoning, myp_applicant,
            myp_proposed_storey, myp_total_proposed_gfa_sqft, myp_proposed_residential_sqft, myp_proposed_retail_sqft,
            myp_proposed_office_sqft, myp_proposed_industrial_sqft, myp_proposed_institutional_sqft
          } = info;
          const devHistory = {
            address, devapp_application_no, myp_label_custom, myp_id, myp_permitapp_id, myp_development_name, myp_address, myp_status, myp_label, myp_type_description, myp_submission_date,
            myp_decision_date, myp_municipality, myp_neighbourward, myp_policy_url, myp_map_url, myp_description, myp_landuse, myp_zoning, myp_applicant,
            myp_proposed_storey, myp_total_proposed_gfa_sqft, myp_proposed_residential_sqft, myp_proposed_retail_sqft,
            myp_proposed_office_sqft, myp_proposed_industrial_sqft, myp_proposed_institutional_sqft,
            acc_type: $rootScope.currentUser.acc_type
          };

          historyService.savedevhistory(devHistory)
            .success(() => {});

          if (typeof info.geometry === 'string') {
            info.geometry = JSON.parse(info.geometry);
          }
        });

        setAddressWindowContent(devAppInfo);
      }
    }).error(() => {});
  };

  const updateDevAddress = (propertyInfo) => {
    $scope.devAddress = propertyInfo.location;
    $scope.devAppFilter.myp_municipality = propertyInfo.myp_municipality;

    if($scope.devAddress == null){
      $scope.devAddress = "Address not available";
    }else {
      var addressList = $scope.devAddress.split(",");
      if (addressList.length > 1) {
        $scope.devAddress = "";
        for (var i = 0; i < addressList.length; i++) {
          if (i <= 2) {
            $scope.devAddress = $scope.devAddress + addressList[i];
          }
        }
      }
    }
    $scope.devAddress = $scope.devAddress + ', ' + propertyInfo.myp_municipality;

    $rootScope.$broadcast('sidebar/report/devaddressupdated', $scope.devAddress);
  };

  const setAddressWindowContent = (devAppInfo) => {
    const position = new google.maps.LatLng($scope.devCoords.lat, $scope.devCoords.lng);    //this line sets the position of the devapp popup on the map. Using clicked position instead of geometry position like before
    const classMoreParagraph = 'dev-desc-more';
    const classLessParagraph = 'dev-desc-less';
    const classMoreButton = 'dev-show-btn';
    const classLessButton = 'dev-less-btn';
    const classHide = 'dev-show-not';
    const items = []
      .concat(devAppInfo)
      .map((item, index) => {
        item.idDesc = `devDesc${index}`;
        item.idShow = `devShow${index}`;
        if (item.myp_description !== null) {
          const showAll = item.myp_description.substring(0,100) && item.myp_description.length < 100;
          item.classParagraph = showAll ?
            classMoreParagraph :
            classLessParagraph;
          item.classButton = showAll ?
            classHide :
            classMoreButton;
        }
        return item;
      });
      console.log('1 - setAddressWindowContent');
    const addressWindowDevTemplate = template(addressWindowDev);
    const renderedTemplate = addressWindowDevTemplate({items});

    $rootScope.$broadcast('map/setaddresswindowcontent', renderedTemplate);
    $rootScope.$broadcast('map/openaddresswindow', [position, true]);
    $rootScope.$broadcast('map/recenter');

    items
      .filter(item => item.classButton !== classHide)
      .forEach((item) => {
        const trigger = document.getElementById(item.idShow);

        if (item.myp_description !== null) {
          google.maps.event.addDomListener(trigger, 'click', function () {
            const desc = document.getElementById(item.idDesc);
            const hiddenDesc = desc.className === classMoreParagraph;
            const expandButton = trigger.className === classMoreButton;

            desc.className = hiddenDesc ?
              classLessParagraph :
              classMoreParagraph;

            trigger.className = expandButton ?
              classLessButton :
              classMoreButton;
          });
        };
      });
  };

  const toggle = (status) => {
    const devAppOverlayIndex = $scope.map.overlayMapTypes.getArray().findIndex((element) => {
      return element && element.alt === 'dev-app-toronto';
    });

    if (devAppOverlayIndex) {
      $scope.map.overlayMapTypes.setAt(
        devAppOverlayIndex,
        status ?
          $scope.filterLayer :
          null
      );
    }
  };

  const devAppFilter = $scope.devAppFilter;
  console.log(devAppFilter);
  $rootScope.$on('sidebar/devapp/update', getHandlerFor(update));
  $rootScope.$on('sidebar/devapp/toggle', getHandlerFor(toggle));
  $rootScope.$on('sidebar/devapp/updatedevcoords', getHandlerFor(updateDevCoords));
  $rootScope.$on('sidebar/devapp/updatedevaddress', getHandlerFor(updateDevAddress));
  $rootScope.$on('sidebar/devapp/updateddevappinfo', getHandlerFor(updateDevAppInfo));

  const reset = () => {
    $scope.datSidebar = Object.assign({}, datSidebar);
  };

  $rootScope.$on('sidebar/devapp/reset', getHandlerFor(reset));

  return {
    devAppFilter,
    update,
    updateDevCoords,
    updateDevAddress,
    setAddressWindowContent,
    updateDevAppInfo,
    reset
  };
};


// WEBPACK FOOTER //
// ./client/controllers/devapp_sidebar.js